<template>
  <div class="product-card">
    <a
      v-if="product.url"
      :href="product.url"
      :target="product.new_window ? '_blank' : '_self'"
    >
      <img
        class="product-card__image"
        :src="product.image"
        alt="Imagem do Produto"
      />
    </a>
    <img
      v-else
      class="product-card__image"
      :src="product.image"
      alt="Imagem do Produto"
    />
    <div class="product-card__info">
      <div v-if="product.name.length <= 30" class="name">
        {{ product.name }}
      </div>
      <div v-else class="name">{{ product.name | slice(0, 27) }}...</div>
      <div class="price">{{ product.price }} BRITZ</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'product-card',
  props: ['product'],
};
</script>

<style lang="scss" scoped>
.product-card {
  width: 275px;

  &__image {
    border-radius: 12px;
    border: 1px solid #d5d5d5;
    width: 275px;
    height: 275px;
    margin-bottom: 8px;
  }

  &__info {
    text-align: center;

    .name {
      font-size: 0.9em;
      font-weight: 500;
      word-break: break-all;
      white-space: nowrap;
    }

    .price {
      text-transform: uppercase;
      color: var(--color-primary);
      font-size: 1em;
      font-weight: bold;
    }
  }
}
</style>
